const CommonSelect = ({ label, options, onChange, onClick }) => {
  return (
    <label className="checkout-custom-select">
      <span>{label}</span>
      <select onChange={onChange}>
        <option>Select {label}</option>
        {options.map((item) => (
          <option
            key={item.value}
            value={item.value}
            onClick={() => onClick(item)}
          >
            {item.name}
          </option>
        ))}
      </select>
    </label>
  );
};
export default CommonSelect;
